import { Icon, IconButton, Stack, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useOwnRepairTimesStore } from "./store"

export function CompilationDetails() {
    const { translateText } = useLocalization()
    const { selectedCompilation, setCompilationToEdit, setCompilationIdsToDelete } = useOwnRepairTimesStore()

    function handleClickEdit() {
        if (selectedCompilation) {
            setCompilationToEdit({
                type: "edit",
                id: selectedCompilation.id,
                name: selectedCompilation.name,
                description: selectedCompilation.description,
                version: selectedCompilation.version,
            })
        }
    }

    function handleClickDelete() {
        if (selectedCompilation) {
            setCompilationIdsToDelete([selectedCompilation.id])
        }
    }

    if (!selectedCompilation) {
        return (
            <Stack direction="row" height="60px">
                <Typography variant="h2">{translateText(14077)}</Typography>
            </Stack>
        )
    }

    const { name, description } = selectedCompilation

    return (
        <Stack direction="row" height="60px" alignItems="start">
            <Stack gap={1} flex={1}>
                <Typography variant="h2">{name}</Typography>
                <Typography variant="body2">{description}</Typography>
            </Stack>

            <Stack direction="row" gap={0.5}>
                <IconButton onClick={handleClickEdit} title={translateText(122)} variant="contained" size="large">
                    <Icon name="edit_change" />
                </IconButton>

                <IconButton onClick={handleClickDelete} title={translateText(69)} size="large" variant="contained">
                    <Icon name="delete" />
                </IconButton>
            </Stack>
        </Stack>
    )
}
